import type {StateProvider, Transition} from '@uirouter/angularjs';
import AccountController from './user-account.controller';
import type {UserAccountControllerData, UserAccountPermissions} from './user-account.controller';
import type UserDataService from './user.data-service';
import type {PermissionsDataService} from '../commons/data-services/permissions.data-service';
import UserService from './user.service';
import type LoginService from '../login/login.service';


/*@ngInject*/
export default function userRoutes($stateProvider: StateProvider) {
    $stateProvider
        .state({
            name: 'user',
            url: '/users/:userId',
            templateUrl: require('./user.tpl.ftl'),
            controller: AccountController,
            controllerAs: 'ac',
            resolve: {
                /*@ngInject*/
                data: async (userService: UserService, userDataService: UserDataService, cachedPermissionsDataService: PermissionsDataService, loginService: LoginService, $transition$: Transition): Promise<UserAccountControllerData> => {
                    try {
                        let userId = $transition$.params().userId;
                        if (userId === UserService.CURRENT_USER_ALIAS) {
                            const auth = await loginService.login();
                            userId = auth.activeUser.id;
                        }
                        const user = await userService.getById(userId);
                        const detailManager = await userDataService.getUserViewManager(userId);
                        const permissions: UserAccountPermissions = await AccountController.getUserPermissions(cachedPermissionsDataService, userId);
                        return {user, detailManager, permissions};
                    } finally {
                        loginService.reloadIfChangedButNotReloaded();
                    }
                }
            }
        });
}
